import type { LivesAt } from '../api/navigation.ts';
import { livesAtLines } from '../livesAt.ts';

/**
 * Where the client lives, as an address (A-#104, A-#117): a facility's name and then its address, or a home's
 * address alone, with the full town line. One component for every "Lives at" (A-#123, A-#772 3): the Client card,
 * the Social Work section's Where they are (WhereaboutsPanel) and the Legal section's standing (CurrentStanding),
 * all from GET /clients/:id/summary's lives_at. Wraps, never cut short. `showAway` is false where the panel draws
 * its own temporary stay line, so a stay is not said twice.
 */
export function LivesAtLines({ at, showAway = true }: { at: LivesAt; showAway?: boolean }) {
  const lines = livesAtLines(at);
  return (
    <span data-lives-at={at.kind} className="break-words">
      {lines.length === 0 ? 'Address not recorded' : lines.map((l, i) => (
        <span key={i} className={i === 0 ? 'block' : 'block text-neutral-700'}>{l}</span>
      ))}
      {showAway && at.away_at && <span className="block font-medium text-neutral-900">Now at {at.away_at}</span>}
    </span>
  );
}
